import {HttpException} from "./http.exception.js";

/**
 * 500 Internal Server Error Exception
 */
export class InternalServerErrorException extends HttpException {
    constructor(message: string = "Internal Server Error", errorBody?: unknown, cause?: Error) {
        super(500, message, errorBody, cause);
    }
}
